import { useQuery } from '@tanstack/react-query';

import { mediaManagerClient } from '@/lib/axios';
import { QueryConfig } from '@/lib/react-query';
import { PaginatedResponse } from '@/types/api';

import { TProgram } from '../types';

import { programsKeys } from './query-keys';

export type ProgramsByParams = {
  idIn?: string[];
  limit?: number;
  segmentStartDatetimeGte?: string;
  segmentEndDatetimeLte?: string;
  clipStartDatetimeGte?: string;
  clipEndDatetimeLte?: string;
};

/**
 * The programme listing driven only by the params given. `getPrograms` reads the Programas
 * page store, so a caller outside that page would inherit whatever was last filtered there.
 */
export async function getProgramsByParams(
  params: ProgramsByParams
): Promise<PaginatedResponse<TProgram>> {
  return mediaManagerClient.get('/api/v1/programs', {
    params: {
      limit: params.limit,
      id__in: params.idIn?.length ? params.idIn.join(',') : undefined,
      segment_start_datetime__gte: params.segmentStartDatetimeGte,
      segment_end_datetime__lte: params.segmentEndDatetimeLte,
      clip_start_datetime__gte: params.clipStartDatetimeGte,
      clip_end_datetime__lte: params.clipEndDatetimeLte,
    },
  });
}

type QueryFnType = typeof getProgramsByParams;

interface UseProgramsByParamsOptions {
  params: ProgramsByParams;
  config?: QueryConfig<QueryFnType>;
}

export function useProgramsByParams({ params, config }: UseProgramsByParamsOptions) {
  return useQuery({
    ...config,
    queryKey: [...programsKeys.all, 'byParams', params],
    queryFn: () => getProgramsByParams(params),
  });
}
